/**
 * MobileVcompProjectsList
 *
 * Mobile-optimized project list for VcompView.
 * Replaces the desktop body() function when isMobile === 2.
 * Renders a scrollable vertical list of ProjectCard components with a search bar.
 */
import React from "react";
import { Box, TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ProjectCard from "../../../components/vcomp/projectCard";

/**
 * @param {Object}   props
 * @param {Array}    props.projects       - filtered project array to display
 * @param {boolean}  props.manage         - whether we are in manage view
 * @param {string}   props.filter         - current search filter string
 * @param {Function} props.onFilterChange - (value) => void
 */
export default function MobileVcompProjectsList({
  projects,
  manage,
  filter,
  onFilterChange,
}) {
  return (
    <Box
      sx={{
        mt: 0,
        px: 1.5,
        pt: 2,
        height: "calc(100vh - 120px)",
        overflowY: "auto",
        WebkitOverflowScrolling: "touch",
      }}
    >
      {/* Search bar */}
      <Box sx={{ mb: 2, px: 0.5 }}>
        <TextField
          fullWidth
          size="small"
          placeholder="Rechercher..."
          value={filter}
          onChange={(e) => onFilterChange(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: "rgba(0,0,0,0.4)", fontSize: 20 }} />
              </InputAdornment>
            ),
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "12px",
              backgroundColor: "rgba(0,0,0,0.03)",
              fontSize: "16px",
              minHeight: 44,
              transition: "all 0.2s ease",
              "& fieldset": {
                borderColor: "rgba(0,0,0,0.08)",
              },
              "&:hover fieldset": {
                borderColor: "rgba(255,144,21,0.3)",
              },
              "&.Mui-focused fieldset": {
                borderColor: "rgb(255,144,21)",
                borderWidth: "2px",
              },
            },
            "& input": {
              fontSize: "16px",
              padding: "10px 12px",
            },
          }}
        />
      </Box>

      {/* Project cards - single column on mobile */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1.5,
          pb: 3,
        }}
      >
        {projects.map((p) => (
          <ProjectCard key={p.id || p.nom} project={p} manage={manage || false} />
        ))}
      </Box>
    </Box>
  );
}
